import React from 'react';
import '../../styles/brand.css';
import './DashShell.css';

// Sidebar + main layout shared by the student and parent dashboards
// (docs/redesign/reference-dashboards.html). Each role passes its OWN nav
// items, so a student's sidebar never contains parent links.
export default function DashShell({ user, navLabel, nav, foot, title, chips, banner, children }) {
  return (
    <div className="tsa-brand dash">
      {banner}
      <div className="dash-shell">
        <aside className="dash-side">
          <div className="dash-logo"><img src="/images/logo-full.png" alt="Talent School Africa" /></div>
          <div className="dash-who">
            <div className="dash-av" style={{ background: user.color }}>{user.initial}</div>
            <div><b>{user.name}</b><span>{user.sub}</span></div>
          </div>
          <nav className="dash-nav" aria-label="Main">
            <div className="dash-nav-l">{navLabel}</div>
            {nav.map(item => (
              <button key={item.label} type="button" className={item.active ? 'on' : ''}
                aria-current={item.active ? 'page' : undefined} onClick={item.onClick}>
                <span className="ic" aria-hidden="true">{item.icon}</span>{item.label}
              </button>
            ))}
          </nav>
          {foot && <div className="dash-foot">{foot}</div>}
        </aside>
        <main className="dash-main">
          <div className="dash-top">
            <h1>{title}</h1>
            {chips && <div className="dash-chips">{chips}</div>}
          </div>
          {children}
        </main>
      </div>
    </div>
  );
}
